export const capitalizeFirstLetter = (value: string | undefined | null) => {
  if (!value) return undefined;
  if (value.length < 1) return '';
  if (value.length === 1) return value.toUpperCase();
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const makeSentenceCase = (value: string | undefined | null) => {
  if (!value) return undefined;
  return capitalizeFirstLetter(value.toLocaleLowerCase());
};
